"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function getTitle(vm) {
    const { title } = vm.$data;
    if (title) {
        return typeof title === 'function'
            ? title.call(vm)
            : title;
    }
}
exports.default = {
    created() {
        const title = getTitle(this);
        if (title) {
            // document DOM title (browser)
            document.title = title;
            // layout title (top-bar)
            this.$store.dispatch('title', { title });
        }
    },
    methods: {
        setTitle(title, badge, delim = '|') {
            if (badge) {
                // title = title + '<span class="sub-title">' + ' <span class="q-badge">' + badge + '</span></span>'
                //title = title + '<span class="sub-title">' + ' ' +  delim + ' ' + badge + '</span>'
                title = title + ' ' + delim + ' ' + badge;
            }
            // document DOM title (browser)
            document.title = String(title).replace(/<[^>]+>/gm, '');
            this.$store.dispatch('title', { title });
        }
    }
};
